import { useEffect } from "react";
import { AppToasterV2, MultiStepItemProps } from "@ucl/library";
import { FinancialApplicationSection } from "@/types/enums";
import { OrganizationAcceptableUseForm } from "./OrganizationAcceptableUseForm";
import { RequireAuth } from "@/lib/auth/RequireAuth";
import { useFinancialApplicationFormSectionValidation, FinancialApplicationFormSectionContextType } from "@/hooks/useFinancialApplicationFormSectionValidation";

export interface OrganizationAcceptableUseFormStepProps extends MultiStepItemProps {
  financialApplicationId: string;
}

export const OrganizationAcceptableUseFormStep: React.FC<OrganizationAcceptableUseFormStepProps> = (
  props
) => {
  return (
    <RequireAuth clientType="consumer">
      <OrganizationAcceptableUseFormStepInner {...props} />
    </RequireAuth>
  );
};

const OrganizationAcceptableUseFormStepInner: React.FC<OrganizationAcceptableUseFormStepProps> = (
  props
) => {
  const { validateFinancialApplicationFormSection } = useFinancialApplicationFormSectionValidation(
    props.financialApplicationId,
    FinancialApplicationSection.OrganizationAccountAcceptableUse
  );

  useEffect(() => {
    props.registerSubmit?.(async () => {
      const { isValid } = await validateFinancialApplicationFormSection();

      if (!isValid) {
        AppToasterV2.showFailedActionToaster(
          "Please correct the highlighted fields to proceed.",
          "Action Required"
        );
        return false;
      }
      return true;
    });
  }, [props.financialApplicationId, validateFinancialApplicationFormSection]);

  return (
    <section className="organization-acceptable-use step-section">
      <div className="organization-acceptable-use__header step-header">
        Additional Information - Business Activities
      </div>
      <div className="organization-acceptable-use__subtitle step-subtitle">
        Please answer these questions to help us better understand your business activities.
      </div>
      <div className="organization-acceptable-use-form__content step-content">
        <OrganizationAcceptableUseForm 
          financialApplicationId={props.financialApplicationId} 
          validationContextType={FinancialApplicationFormSectionContextType.Applicant}
        />
      </div>
    </section>
  );
};
